import React from "react"
import styled from "styled-components"

const RightArrow = styled.button`
  width: 50px;
  color: inherit;
  height: 110px;
  background-color: #c5050c;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  border: none;
  span {
    color: #fff;
    font-size: 2.5em;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1, 1.75);
  }
  display: none;
  @media screen and (min-width: 936px) {
    display: block !important;
  }
  &.disabled {
    opacity: .25;
    cursor: default;
  }
`

const SliderArrowRight = props => {
  const { onClick, className } = props
  const disabledClass = className?.includes("slick-disabled") ? " disabled" : ''

  return (
    <RightArrow className={`slider-arrow slider-arrow-right ${disabledClass}`} onClick={onClick} disabled={className?.includes("slick-disabled")}>
      <span>&#62;</span>
    </RightArrow>
  )
}

export default SliderArrowRight
